import { useEffect, useState } from 'react'
import Chart from "react-apexcharts";
import { PastYearSelection, getMonthNumber, monthName } from '../../utils/Helper';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { SalesGrowthCountAction, SalesGrowthGetAction } from '../../redux/Action/SalesGrowthAction';
import Spinner from '../../components/Spinner';
import moment from 'moment';
import $ from "jquery";

const SalesGrowth = () => {
    const dispatch = useDispatch<any>();
    const salesGrowthData = useSelector((state: any) => state.SalesGrowthGetState);
    const salesGrowthCount = useSelector((state: any) => state.SalesGrowthCountState);
    const years: any = PastYearSelection();
    const currentYear = new Date().getFullYear();
    const [disableDate, setDisableDate] = useState(true)
    // Always English so it matches monthName / monthMap (locale e.g. sq-AL → "gusht" broke API)
    const currentMonthName = new Date().toLocaleString('en-US', { month: 'long' });
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedMonth, setSelectedMonth]: any = useState(currentMonthName)
    const [startDate, setStartDate]: any = useState();
    const [endDate, setEndDate]: any = useState();

    const [chartData, setChartData]: any = useState({
        options: {
            chart: {
                id: "basic-bar",
            },
            plotOptions: {
                bar: {
                    columnWidth: '15%',
                    borderRadius: 5,
                    dataLabels: {
                        position: 'top',
                        offsetX: 30
                    },
                },
            },
            xaxis: {
                categories: monthName,
                title: {
                    text: 'UNIT - TIME',
                    style: {
                        fontSize: '12px',
                        fontWeight: '300',
                        color: '#AAAAAA',
                    }
                }
            },
            yaxis: {
                title: {
                    text: 'UNIT - BOOKING',
                    style: {
                        fontSize: '12px',
                        fontWeight: '300',
                        color: '#AAAAAA',
                    }
                }
            },
        },
        series: [
            {
                name: "series-1",
            }
        ]
    });



    useEffect(() => {
        if (salesGrowthData?.data?.data?.length > 0) {
            const arr: any = [];
            salesGrowthData?.data?.data?.forEach((item: any) => {
                arr.push(item.total_bookings);
            });


            if (selectedYear && selectedMonth) {
                const selectedMonth = monthName.indexOf(currentMonthName);
                const daysInMonth = getDaysInMonth(selectedMonth, currentYear);

                setChartData((prevState: { options: { xaxis: any; }; series: any[]; }) => ({
                    ...prevState,
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            categories: daysInMonth,
                        },
                    },
                    series: [
                        {
                            ...prevState.series[0],
                            data: arr ? arr : new Array(daysInMonth.length).fill(0)
                        }
                    ]
                }));
            }

            if (selectedYear && !selectedMonth) {
                setChartData((prevState: { options: { xaxis: any; }; series: any[]; }) => ({
                    ...prevState,
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            categories: monthName,
                        },
                    },
                    series: [
                        {
                            ...prevState.series[0],
                            data: arr.length > 0 ? arr : new Array(12).fill(0)
                        }
                    ]
                }));
            }


            // if (selectedYear && !selectedMonth) {

            //     setChartData((prevState: { options: { xaxis: any; }; series: any[]; }) => ({
            //         ...prevState,
            //         options: {
            //             ...prevState.options,
            //             xaxis: {
            //                 ...prevState.options.xaxis,
            //                 categories: daysInMonth,
            //             },
            //         },
            //         series: [
            //             {
            //                 ...prevState.series[0],
            //                 data: arr ? arr : new Array(daysInMonth.length).fill(0)
            //             }
            //         ]
            //     }));
            //     // setChartData((prevState: any) => ({
            //     //     ...prevState,
            //     //     series: [
            //     //         {
            //     //             ...prevState.series[0],
            //     //             data: arr ? arr : new Array().fill(0),
            //     //         },
            //     //     ],
            //     // }));
            // }
        }
    }, [salesGrowthData]);



    const getDaysInMonth = (month: any, year: any) => {
        return new Array(new Date(year, month + 1, 0).getDate()).fill(null).map((_, i) => i + 1);
    };


    const handleMonthChange = (event: any) => {

        const selectedMonth: any = monthName.indexOf(event.target.value);
        const daysInMonth = getDaysInMonth(selectedMonth, currentYear);
        let arr: any = [];
        setSelectedMonth(event.target.value)
        if (salesGrowthData?.data?.data?.length > 0) {
            salesGrowthData?.data?.data?.forEach((item: any) => {
                arr.push(item.total_bookings)
            });
            setChartData((prevState: { options: { xaxis: any; }; series: any[]; }) => ({
                ...prevState,
                options: {
                    ...prevState.options,
                    xaxis: {
                        ...prevState.options.xaxis,
                        categories: daysInMonth,
                    },
                },
                series: [
                    {
                        ...prevState.series[0],
                        data: arr ? arr : new Array(daysInMonth.length).fill(0)
                    }
                ]
            }));
        };

    }

    const handleYearChange = (event: any) => {
        const selectedYear = event.target.value;
        let arr: any = [];
        $('.month_select').val('');
        setSelectedMonth('');
        setSelectedYear(selectedYear);


        if (salesGrowthData?.data?.data?.length > 0) {
            salesGrowthData?.data?.data?.forEach((item: any) => {
                arr.push(item.total_bookings);
            });

            setChartData((prevState: any) => ({
                ...prevState,
                series: [
                    {
                        ...prevState.series[0],
                        data: arr,
                    },
                ],
            }));
        }
    };

    useEffect(() => {
        const monthNumber = selectedMonth ? getMonthNumber(selectedMonth) : null;
        dispatch(SalesGrowthGetAction({
            year: selectedYear ? selectedYear : currentYear,
            ...(monthNumber ? { month: monthNumber } : {}),
        }));
    }, [selectedMonth, selectedYear])

    useEffect(() => {
        dispatch(SalesGrowthCountAction({
            ...(startDate && { "start_date": moment(startDate).format("YYYY-MM-DD") }), ...(endDate && { "end_date": moment(endDate).format("YYYY-MM-DD") })
        }));

    }, [startDate, endDate])



    return (
        <>
            {/* <Header /> */}
            <div className='col-lg-9'>
                {salesGrowthData?.loading  ? <Spinner /> : ""}
                {/* {salesGrowthData?.loading || salesGrowthCount?.loading ? <Spinner /> : ""} */}
                <div className='dashboard bg-white'>
                    <div className='dashboardTop'>
                        <h2><button type='button' className='btn mobileMenu p-1 d-lg-none'><span className="icon-menu-right"></span></button> <FormattedMessage id="sales_and_growth" /></h2>
                    </div>
                    <div className='filterdate'>


                        <div className="mb-3 normalInput">
                            <div className='datepicker normalINput'>
                                <label className="form-label d-block"><FormattedMessage id="from" /></label>
                                <DatePicker
                                    className='form-control'
                                    placeholderText="MM/DD/YYYY"
                                    timeFormat="MM DD YYYY"
                                    onKeyDown={(e: any) => e.preventDefault()}
                                    showYearDropdown
                                    scrollableYearDropdown
                                    yearDropdownItemNumber={50}
                                    selected={startDate}
                                    showIcon
                                    onChange={(start_date: any) => {
                                        setStartDate(start_date)
                                        setDisableDate(false);
                                        setEndDate(null)
                                    }}
                                />
                            </div>
                        </div>
                        <div className="mb-3 normalInput">
                            <div className='datepicker normalINput'>
                                <label className="form-label d-block"><FormattedMessage id="to" /></label>
                                <DatePicker
                                    className="form-control"
                                    // placeholderText={intl.formatMessage({ id: 'month' })}
                                    placeholderText="MM/DD/YYYY"
                                    timeFormat="MM DD YYYY"
                                    onKeyDown={(e: any) => e.preventDefault()}
                                    showYearDropdown
                                    scrollableYearDropdown
                                    yearDropdownItemNumber={50}
                                    selected={endDate}
                                    showIcon
                                    disabled={disableDate}
                                    minDate={startDate}
                                    toggleCalendarOnIconClick
                                    onChange={(end_date: any) => {
                                        setEndDate(end_date)
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className='dashCard'>
                        <div className='row row-cols-2 row-cols-sm-3 row-cols-lg-6 g-3'>
                            <div className='col'>
                                <div className='D_card color1'>
                                    <p className='topNumber'>{salesGrowthCount?.data?.data?.totalbooking ? salesGrowthCount?.data?.data?.totalbooking : "00"}</p>
                                    <p><FormattedMessage id="all-booking" /></p>
                                </div>
                            </div>
                            <div className='col'>
                                <div className='D_card color2'>
                                    <p className='topNumber'>{salesGrowthCount?.data?.data?.totalcompaletedBooking ? salesGrowthCount?.data?.data?.totalcompaletedBooking : "00"}</p>
                                    <p><FormattedMessage id="completed" /> <br /><FormattedMessage id="booking" /></p>
                                </div>
                            </div>
                            <div className='col'>
                                <div className='D_card color3'>
                                    <p className='topNumber'>{salesGrowthCount?.data?.data?.totalcancelBooking ? salesGrowthCount?.data?.data?.totalcancelBooking : "00"}</p>
                                    <p><FormattedMessage id="cancelled" /> <br /><FormattedMessage id="booking" /></p>
                                </div>
                            </div>
                            <div className='col'>
                                <div className='D_card color4'>
                                    <p className='topNumber'>{salesGrowthCount?.data?.data?.totalNoshownbooking ? salesGrowthCount?.data?.data?.totalNoshownbooking : "00"}</p>
                                    <p><FormattedMessage id="no" /> <br /><FormattedMessage id="shown_up" /></p>
                                </div>
                            </div>
                            <div className='col'>
                                <div className='D_card color5'>
                                    <p className='topNumber'>${salesGrowthCount?.data?.data?.totalRevenue ? salesGrowthCount?.data?.data?.totalRevenue : "00"}</p>
                                    <p><FormattedMessage id="revenue" /> <br /><FormattedMessage id="generated" /></p>
                                </div>
                            </div>
                            <div className='col'>
                                <div className='D_card color6'>
                                    <p className='topNumber'>{salesGrowthCount?.data?.data?.totalOnlineBooking ? salesGrowthCount?.data?.data?.totalOnlineBooking : "00"}</p>
                                    <p><FormattedMessage id="online" /> <br /><FormattedMessage id="booking" /></p>
                                </div>
                            </div>
                            <div className='col'>
                                <div className='D_card color7'>
                                    <p className='topNumber'>{salesGrowthCount?.data?.data?.totalOfflineBooking ? salesGrowthCount?.data?.data?.totalOfflineBooking : "00"}</p>
                                    <p><FormattedMessage id="offline" /> <br /><FormattedMessage id="booking" /></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="chart">
                        <h6><FormattedMessage id="sales_and_growth" /></h6>
                        <div className='filterdate'>

                            <div className="mb-3 normalInput">
                                <label className="form-label"><FormattedMessage id="sales_performance" /></label>
                                <select className='form-select' defaultValue={selectedYear} onChange={handleYearChange}>
                                    {
                                        years?.map((item: any) => {
                                            return (
                                                <option key={item}>{item}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>

                            <div className="mb-3 normalInput">
                                <label className="form-label"><FormattedMessage id="select_year_period" /></label>
                                <select className='form-select month_select' defaultValue={selectedMonth} onChange={handleMonthChange}>
                                    <option value=""><FormattedMessage id="select_month_period" /></option>
                                    {monthName?.map((item) => (
                                        <option key={item} value={item}>{item}</option>
                                    ))}
                                </select>
                            </div>

                        </div>

                        <div className="mixed-chart">
                            <Chart
                                options={chartData.options}
                                series={chartData.series}
                                type="bar"
                            // width="500"
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* <Footer /> */}
        </>
    )
}

export default SalesGrowth
